import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TestimonialComponent } from './testimonial/testimonial.component';
import { ShareService } from '../service/share.service';
import { kesariAnimations } from '../animation';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-testimonial-section',
  templateUrl: './testimonial-section.component.html',
  styleUrls: ['./testimonial-section.component.scss'],
  animations: kesariAnimations,
})
export class TestimonialSectionComponent implements OnInit {
  testimonial: any;
  metaData = {
    isProduct: false,
    page: "MICE-TESTIMONIAL"
  }
  constructor(@Inject(DOCUMENT) private dom,public dialog: MatDialog, private miceService: ShareService, private meta: Meta,
    private title: Title) { }

  ngOnInit(): void {
    this.getTestimonial()
  }
  getTestimonial() {
    this.miceService.getTestimonials().subscribe((param) => {
      //console.log(param)
      this.testimonial = param
    })
    this.miceService.getMetaData(this.metaData).subscribe((data) => {
      // console.log(data)
      if (data.length != 0) {
        this.meta.updateTag({ property: 'og:title', content: data[0].meta_title });
        this.meta.updateTag({ name: 'keywords', content: data[0].meta_keyword });
        this.meta.updateTag({ name: 'description', content: data[0].meta_description });
        this.title.setTitle(data[0].meta_title);
        // console.log(data[0].meta_description)
      }
      let link: HTMLLinkElement = this.dom.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.dom.head.appendChild(link);
      link.setAttribute('href', this.dom.URL);
      console.log(this.dom.URL)
    })
  }
  openDialog(item) {
    this.dialog.open(TestimonialComponent, {
      width: '900px',
      data: item,
      disableClose: true,
      hasBackdrop: true
    });

  }
}
